import { render } from "./OfficialReleaseDialog.vue?vue&type=template&id=0407a962&scoped=true"
import script from "./OfficialReleaseDialog.vue?vue&type=script&lang=js"
export * from "./OfficialReleaseDialog.vue?vue&type=script&lang=js"

import "./OfficialReleaseDialog.vue?vue&type=style&index=0&id=0407a962&scoped=true&lang=css"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0407a962"]])

export default __exports__